import { ReactToggle as S } from '../../styles/styles';

const ReactToggleThumb = ({ modePosition }: { modePosition: number }) => {
  return <S.ReactToggleThumb {...{ modePosition }} />;
};

export default ReactToggleThumb;
